<template>
    <v-img :src="backgroundUrl" class="mnt_image fill-height">
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <div id="landing" class="elevation-24">
                        <!-- <v-img :src="logo_img" width="210" class="d-block" style="margin: 0 auto" atl="Succession Resource Group"></v-img> -->
                        <v-img :src="logo_img" width="182" class="d-block" style="margin: 0 auto" atl="Succession Resource Group"></v-img>
                        <div class="sansation grey--text text--darken-3 mx-1 mt-9 mb-6 title">Welcome to myCompass</div>
                        <div class="mx-0 my-2">This application is best utilized on the latest desktop browsers like Chrome, Firefox, Safari, or Edge etc.</div>
                        <a class="return_link sansation" href="https://www.successionresource.com">Return to SRG Home Page</a>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </v-img>
</template>

<script>
    import logo_img from '../assets/SRGLogo_full_color_2022.svg';
    import backgroundUrl from '../assets/mycompass_loginbkg_mnt.jpg';

    export default {
        name: 'MobileLanding',

        data () {
            return {
                logo_img: logo_img,
                backgroundUrl: backgroundUrl
            }
        },

        created () {
            document.title = 'SRG myCompass: Mobile'
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #landing {
        margin: 10% 2%;
        padding: 9% 3%;
        text-align: center;
        font-size: .8rem;
        background: rgba(255, 255, 255, 0.85);
        border-radius: 8px;
    }
    .mnt_image {
        background-position: top left; 
        background-repeat: no-repeat; 
        background-attachment: fixed; 
        background-size: cover;
    }
    .return_link {
        font-size: 1.25rem;
        text-decoration: none;
        /* mdi-keyboard-backspace */
    }
    .title {
        /* color: #37383C; */
        font-weight: 600;
        font-size: 1.5rem !important;
        letter-spacing: 0.05rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/MobileLanding.vue